import { useTranslation } from 'react-i18next'

const Requested = () => {
  const { t } = useTranslation(['parking'])
  return (
    <div className="badge requested">
      <div className="header">{t('parking:statusBadge.requested.header')}</div>
      <div className="subheader">{t('parking:statusBadge.textWhenReady')}</div>
    </div>
  )
}

export default Requested
